<template>
<div v-if="!$isGirlsAndSteam" class="containers" :class="{'containers_isef' : this.$isIsef, 'white-background' :  !this.$isIsef}" >
  <div :class="{'curved-background' : !this.$isIsef}"></div>
  <ul class="categories is-mobile" :class="{'is-ios' : isIOS, 'is-centered' : inViewport}" ref="categories"  @scroll="scrollBlocks" qa="category-bubbles">
    <li v-for="category in categories" :key="category.name" class="category-container" :class="{ 'is-inactive': selectedCategoryID > 0 && selectedCategoryID !== category.id && category.id !== parentCategoryID && category.id !== grandparentCategoryID}" :qa="category.name">
      <div class="sponsor-container" :class="category.slug.toLowerCase()">
        <div v-if="(parentCategoryID === 0 || category.id === grandparentCategoryID) && !category.subCategories && $isEngCom" >
          <!-- Render nothing if the category has no parent -->
        </div>
        <div v-else-if="category.sponsorLink !== ''" :class="{'sponsor-container-isef' : $isIsef}">
          <a :href="getUTMLink(category.sponsorLink, 'sponsor')" target="_blank" :aria-label="`Sponsored ad by ${category.sponsor}`"><img class="sponsor-image cursor-pointer is-flex" :class="{'max-height' : $isYSC}" :src="category.sponsorImage" :alt="category.sponsorImage"></a>
        </div>
        <div v-else-if="$isIsef" :class="{'sponsor-container-isef' : $isIsef}">
          <img class="sponsor-image is-flex" :src="category.sponsorImage" :alt="category.sponsorImage">
        </div>
        <div v-else>
          <img class="sponsor-image is-flex" :class="{'max-height' : $isYSC}" :src="category.sponsorImage" :alt="category.sponsorImage">
        </div>
      </div>
      <div class="category-image-container is-flex" v-bind="categoryTooltip(category)" @click="select(category)">
        <div class="category-image-shadow">
          <div class="category-image-circle" :class="{'isefBorder': $isIsef}">
            <img :class="'category-image cursor-pointer is-flex gtm-category-'+category.slug.toLowerCase()" :src="proxyImage(category.image)" :alt="category.slug">
          </div>
        </div>
        <category-star v-if="isLoggedIn && checkCategoryPreference(category)" :context="`big`"></category-star>
      </div>
      <div class="category-title" :class="{'isef-category-title': $isIsef}">{{category.name}}</div>
    </li>
  </ul>
  <div v-if="!isMobile && categories.length > 0" class="button-container">
    <div v-if="scrollLeft !== 0" class="start scroll-arrow cursor-pointer" :class="{'sponsor': showSponsor}" @mousedown="clickLeft" @mouseout="stopScroll" @mouseup="stopScroll" @touchstart="clickLeft" @touchend="stopScroll" @touchcancel="stopScroll" @keyup.enter="clickLeft" aria-label="Scroll left" tabindex="0">
      <i class="fal fa-chevron-left" aria-hidden="true"></i>
    </div>
    <div v-if="!inViewport" class="end scroll-arrow cursor-pointer" :class="{'sponsor': showSponsor}" @mousedown="clickRight" @mouseout="stopScroll" @mouseup="stopScroll" @touchstart="clickRight" @touchend="stopScroll" @touchcancel="stopScroll" @keyup.enter="clickRight" aria-label="Scroll right" tabindex="0">
      <i class="fal fa-chevron-right" aria-hidden="true"></i>
    </div>
  </div>
</div>
</template>

<script>
import CategoryStar from '@/components/Controls/CategoryStar'

import userAgent from '@/libs/user-agent'
import imageProxy from '@/libs/image-proxy'

import componentState from '@/mixins/component-state'
import auth from '@/mixins/auth'
import utmTracking from '@/mixins/utm-tracking'

export default {
  props: ['selectedCategoryID', 'userCategories', 'showSponsor', 'isScienceDay', 'isBuckeye'],
  mixins: [componentState, auth, utmTracking],
  components: { CategoryStar },
  data: function () {
    return {
      scrollLeft: 0,
      interval: false,
      inViewport: true
    }
  },
  watch: {
    categories: function () {
      this.$nextTick(() => this.checkIfInViewport())
    },
    scrollLeft: function () {
      this.checkIfInViewport()
    },
    selectedCategoryID: function () {
      if (this.selectedCategoryID > 0) {
        this.scrollToCategory()
      }
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.toggleListeners('add')
      this.checkIfInViewport()
    })
  },
  destroyed: function () {
    this.toggleListeners('remove')
  },
  computed: {
    categories: function () {
      // do not show private categories in category explore row
      let categories = this.$store.getters.categoriesLoaded ? this.$store.getters.projectCategories() : []
      if (categories.length > 0) {
        categories = categories.filter(category => !category.isPrivate)
      }
      return categories
    },
    isIOS: function () {
      return userAgent.isIOS()
    },
    isMobile: function () {
      return userAgent.isAllMobile()
    },
    parentCategoryID: function () {
      return this.selectedCategoryID > 0 ? this.$store.getters.categoryByID(this.selectedCategoryID).parentID || this.selectedCategoryID : 0
    },
    grandparentCategoryID: function () {
      return this.parentCategoryID > 0 ? this.$store.getters.categoryByID(this.parentCategoryID).parentID || this.parentCategoryID : 0
    },
    userCategoriesIDs: function () {
      const userCatIDs = []
      var i
      for (i = 0; i < this.userCategories.length; i++) {
        userCatIDs.push(this.userCategories[i].id)
      }
      return userCatIDs
    },
    showStar: function () {
      return this.userCategoriesIDs.indexOf(this.category.id)
    }
  },
  methods: {
    select: function (category) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'trackCategory',
          CategoryID: category.id,
          CategoryName: category.slug
        })
      }
      if (category.id === this.selectedCategoryID) {
        this.$router.push({
          name: 'home',
          query: { r: this.refreshKey() }
        })
      } else if (category.subCategories) {
        if (this.$route.params.category === category.slug) {
          this.$emit('viewCategory', category.name)
        } else {
          this.$router.push({ name: 'projectsCategory', params: { category: category.slug } })
        }
      } else {
        this.$router.push({ name: 'viewAll', query: { category: category.slug, isScienceDay: this.isScienceDay, isBuckeye: this.isBuckeye } })
      }
    },
    checkIfInViewport: function () {
      if (this.$refs.categories && this.$refs.categories.children.length > 0) {
        const bounding = this.$refs.categories.children[this.categories.length - 1].getBoundingClientRect()
        const rightSide = Math.min(document.documentElement.clientWidth, window.innerWidth)
        if (bounding.top >= 0 && bounding.left >= 0 && bounding.right <= rightSide && bounding.bottom <= rightSide) {
          this.inViewport = true
        } else {
          this.inViewport = false
        }
      }
    },
    clickLeft: function () {
      if (!this.interval) {
        this.interval = setInterval(() => this.scrollLeftCat(), 10)
      }
    },
    clickRight: function () {
      if (!this.interval) {
        this.interval = setInterval(() => this.scrollRight(), 10)
      }
    },
    scrollRight: function () {
      if (!this.$refs.categories) {
        return
      }
      if (!this.$refs.categories.scrollLeft) {
        this.$refs.categories.scrollLeft = 0
      }
      if (!this.inViewport) {
        this.$refs.categories.scrollLeft += 20
        this.scrollLeft = this.$refs.categories.scrollLeft
        this.checkIfInViewport()
      }
    },
    scrollLeftCat: function () {
      if (!this.$refs.categories) {
        return
      }
      if (!this.$refs.categories.scrollLeft) {
        this.$refs.categories.scrollLeft = 0
        this.stopScroll()
      }
      this.$refs.categories.scrollLeft -= 20
      this.scrollLeft = this.$refs.categories.scrollLeft
      this.checkIfInViewport()
    },
    stopScroll: function () {
      clearInterval(this.interval)
      this.interval = false
    },
    scrollBlocks: function () {
      this.scrollLeft = this.$refs.categories.scrollLeft
    },
    proxyImage: function (src) {
      return imageProxy.category(src)
    },
    refreshKey: function () {
      return (Math.random() + 1).toString(36).substring(7)
    },
    toggleListeners: function (key) {
      window[`${key}EventListener`]('resize', this.checkIfInViewport)
    },
    checkCategoryPreference: function (category) {
      const catOrSubCat = category.subCategories || [category.id]
      const matches = this.userCategoriesIDs.filter(cat => catOrSubCat.includes(cat))
      return matches.length > 0
    },
    scrollToCategory: function () {
      setTimeout(() => {
        let selectedCat = document.querySelector('ul.categories > .category-container:not(.is-inactive)')
        if (selectedCat) {
          if (selectedCat.nextSibling) {
            selectedCat = selectedCat.nextSibling
          }
          selectedCat.scrollIntoView({
            behavior: 'smooth'
          })
        } else {
          // if failed to get selectedCategory, just scroll to top
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }, 1000)
    },
    categoryTooltip: function (category) {
      if (this.isMobile || category.description === '') {
        return
      }
      const tooltip = {}
      tooltip['data-balloon'] = category.description
      tooltip['data-balloon-pos'] = 'up'
      return tooltip
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.containers{
  padding: 1rem 0;
  position: relative;
  -ms-overflow-style: none;
  overflow-x: -moz-scrollbars-none;

  &_isef {
    color: white;
  }

  &.white-background {
    background: var(--background-story-card);
  }
}
.curved-background {
  position: absolute;
  width: 100%;
  bottom: 0;
  height: 60%;
  background: var(--background-fifth);
  border-top-left-radius: 100%;
  border-top-right-radius: 100%;
}
.is-inactive{
  opacity: 0.5;
}
::-webkit-scrollbar {
  display: none;
  background: transparent;
}
.categories {
  margin-left: 1.3rem;
  margin-right: 1.3rem;
  padding-top: 1rem;
  overflow: hidden;
  display: flex;
  position: relative;
  overflow-x: auto;
  &.is-centered {
    @media only screen {
      justify-content: center;
    }
  }
  @include tablet-only{
    margin-right: 1.3rem;
  }
  @include mobile{
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-bottom: 0.5rem;
  }
  @include fix-ios-scrolling;

  .category-container{
    width: 9rem;
    min-width: 8rem;
    text-align: center;
    justify-content: flex-end;
    align-items: flex-end;
    @include mobile{
      width: 7.3rem;
      min-width: 7.3rem;
    }
    .category-image-container{
      justify-content: flex-end;
      align-items: flex-end;
      margin: 0 auto;
      position: relative;
    }
    // Needed a separate div for the shadow and one for the cropped circle specifically for Safari
    .category-image-shadow {
      position: relative;
      height: 7.5rem;
      width: 7.5rem;
      box-shadow: $default-shadow;
      border-radius: 50%;
      margin: 0 auto;
      overflow: hidden;
      @include mobile{
        height: 6.5rem;
        width: 6.5rem;
      }
    }
    .category-image-circle {
      width: 100%;
      height: 100%;
      clip-path: circle(50% at 50% 50%);
      &:hover,
      &:focus,
      &:active {
        img {
          transform: scale(1.1);
          @include touch {
            transform: none;
          }
        }
      }
      &.isefBorder {
        border: 3px solid white;
        border-radius: 50%;
      }
    }
    .category-image{
      max-width: 100%;
      transition: all 0.2s;
    }
    .sponsor-container {
      display: flex;
      align-items: center;
      margin: 0.5rem auto;
      height: 40px;
      max-width: 94%;
      &.how-to,
      &.digital-fabrication {
        max-width: 90px;
      }
      &.technology {
        max-width: 110px;
      }
      &.craft-and-design,
      &.home-diy {
        max-width: 120px;
      }
      &.home-de {
        max-width: 60%;
      }
    }
    .sponsor-image {
      margin: 0 auto;
    }
    .max-height {
       max-height: 100%;
    }
    .category-title{
      word-wrap: break-word;
      color: var(--font-colour);
      line-height: 1.3;
      font-size: 0.8rem;
      font-weight: 400;
      margin-top: 0.75rem;
      padding: 0 0.5rem;
      @include mobile {
        font-size: 0.7rem;
      }
    }
    .isef-category-title {
      color: white;
    }
  }
}

.categories.is-ios {
  overflow-x: scroll;
  margin-left: 0;
  padding-left: 0;
}

.column {
  padding: 0.4rem;
}

.button-container {
  position: absolute;
  top: 1.25rem;
  left: 0;
  right: 0;

  .scroll-arrow {
    height: 7.5rem;
    position: absolute;
    top: 4.2rem;
    background: black;
    opacity: 0.7;
    padding: 0.6rem 0.4rem;
    display:flex;
    align-items: center;
    i {
      color: #fff;
    }
  }

  .start {
    left: 1.3rem;
  }

  .end {
    right: 1.3rem;
  }

  .sponsor {
    height: 7.5rem;
    top: 4.2rem;
  }
}

.sponsor-container-isef {
  margin-bottom: 1rem;
}

@include mobile {
  .button-container {
    .scroll-arrow:not(.sponsor) {
      height: 7rem;
    }
    .start {
      left: 0;
    }
    .end {
      right: 0;
    }
    .sponsor {
      height: 6.5rem;
    }
    .category-container {
      .sponsor-image {
        max-height: 35px;
      }
    }
  }
}
</style>
